// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storybook-view {
    border-top: 1px solid #e8e8e8;
}

.storybook-view h4 {
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.75rem;
    margin-bottom: 1rem;
}

.storybook-view a {
    display: inline;
    background: linear-gradient(to top, #ffd831 0%, #ffd831 15%, transparent 15%);
    transition: all 300ms ease-in-out;
}

.storybook-view a:hover {
    background: linear-gradient(to top, #ffd831 0%, #ffd831 100%, transparent 100%);
}

.storybook-view a:before {
    display: none;
}

.storybook-view .plan-reveal {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
}

.storybook-view .col-8 ul {
    list-style-type: disc;
    padding-left: 1em;
}

.storybook-view .col-8 ul+p,
.storybook-view .col-8 ul+h3 {
    margin-top: 1rem;
}

.storybook-view .col-8 ul:last-of-type {
    margin-bottom: 1rem;
}

.storybook-view .col-8 h2:not(.question-text) {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1rem;
}

.storybook-view .col-8 h3 {
    font-size: 1.5rem;
    font-weight: 700;
}

.storybook-view .col-8 i,
.storybook-view .col-8 em {
    font-style: italic;
}

.storybook-view .col-8 .print-button-icon {
    background: white;
    border: 2px solid #6F6F85;
    border-radius: 6px;
    padding: 0 0.5rem;
    margin-bottom: 1rem;
    font-size: 0.9rem;
}

.storybook-view .col-8 .print-button-icon:hover {
    background: #2f2f52;
    border-color: #2f2f52;
}

.storybook-view .col-8 .print-button-icon .fa.fa-print {
    margin-right: 6px;
    color: #6F6F85;
}

@media print {
    .conversation {
        display: block !important;
    }

    .conversation .col-4 {
        display: none;
    }
}

#skip {
    top: 0px !important;
}

.modal-close {
    top: auto !important;
}

/* contains the overlay within the storybook frame */
.dreamcast-scope .overlay {
    position: absolute;
}

.dreamcast-scope .conversation {
    position: relative;
}`, "",{"version":3,"sources":["webpack://./node_modules/@jellyvision/storybook-runtime/dist/StorybookRuntime/styles/storybookStyles.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6EAA6E;IAC7E,iCAAiC;AACrC;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,oDAAoD;AACpD;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".storybook-view {\n    border-top: 1px solid #e8e8e8;\n}\n\n.storybook-view h4 {\n    font-size: 1.125rem;\n    font-weight: 700;\n    line-height: 1.75rem;\n    margin-bottom: 1rem;\n}\n\n.storybook-view a {\n    display: inline;\n    background: linear-gradient(to top, #ffd831 0%, #ffd831 15%, transparent 15%);\n    transition: all 300ms ease-in-out;\n}\n\n.storybook-view a:hover {\n    background: linear-gradient(to top, #ffd831 0%, #ffd831 100%, transparent 100%);\n}\n\n.storybook-view a:before {\n    display: none;\n}\n\n.storybook-view .plan-reveal {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    width: 100%;\n}\n\n.storybook-view .col-8 ul {\n    list-style-type: disc;\n    padding-left: 1em;\n}\n\n.storybook-view .col-8 ul+p,\n.storybook-view .col-8 ul+h3 {\n    margin-top: 1rem;\n}\n\n.storybook-view .col-8 ul:last-of-type {\n    margin-bottom: 1rem;\n}\n\n.storybook-view .col-8 h2:not(.question-text) {\n    font-size: 2rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n}\n\n.storybook-view .col-8 h3 {\n    font-size: 1.5rem;\n    font-weight: 700;\n}\n\n.storybook-view .col-8 i,\n.storybook-view .col-8 em {\n    font-style: italic;\n}\n\n.storybook-view .col-8 .print-button-icon {\n    background: white;\n    border: 2px solid #6F6F85;\n    border-radius: 6px;\n    padding: 0 0.5rem;\n    margin-bottom: 1rem;\n    font-size: 0.9rem;\n}\n\n.storybook-view .col-8 .print-button-icon:hover {\n    background: #2f2f52;\n    border-color: #2f2f52;\n}\n\n.storybook-view .col-8 .print-button-icon .fa.fa-print {\n    margin-right: 6px;\n    color: #6F6F85;\n}\n\n@media print {\n    .conversation {\n        display: block !important;\n    }\n\n    .conversation .col-4 {\n        display: none;\n    }\n}\n\n#skip {\n    top: 0px !important;\n}\n\n.modal-close {\n    top: auto !important;\n}\n\n/* contains the overlay within the storybook frame */\n.dreamcast-scope .overlay {\n    position: absolute;\n}\n\n.dreamcast-scope .conversation {\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
